var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60059 5.84961H3.90059V7.14961H2.60059V5.84961ZM2.60059 8.44961H3.90059V9.74961H2.60059V8.44961ZM5.20059 5.84961H6.50059V7.14961H5.20059V5.84961ZM5.20059 8.44961H6.50059V9.74961H5.20059V8.44961ZM7.80059 5.84961H9.10059V7.14961H7.80059V5.84961ZM7.80059 8.44961H9.10059V9.74961H7.80059V8.44961Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3 13H10.4C11.1169 13 11.7 12.4169 11.7 11.7V2.6C11.7 1.88305 11.1169 1.3 10.4 1.3H9.1V0H7.8V1.3H3.9V0H2.6V1.3H1.3C0.58305 1.3 0 1.88305 0 2.6V11.7C0 12.4169 0.58305 13 1.3 13ZM10.4 3.9L10.4006 11.7H1.3V3.9H10.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIconBlack);
export default __webpack_public_path__ + "static/media/calenderIconBlack.bd20a0083b8ba8c135484bc585050bca.svg";
export { ForwardRef as ReactComponent };